import * as React from 'react';
import { Section, Viewer } from '../../modules';
import { Profile, User, UserFactory } from '../../resource/'; 
import { RouteComponentProps } from 'react-router';
import { IAuthProps } from '../../services/Auth';
import { ListLogs } from '../Log/ListLogs';

import { Icon } from '@independent-software/typeui/controls/Icon';
import { Tabs } from '@independent-software/typeui/controls/Tabs';
import { Header } from '@independent-software/typeui/controls/Header';
import { Flex } from '@independent-software/typeui/controls/Flex';
import { Gravatar } from '@independent-software/typeui/controls/Gravatar';
import { ToastService } from '@independent-software/typeui/controls/Toast';
import { Label } from '@independent-software/typeui/controls/Label';
import { Datum } from '@independent-software/typeui/formatters/Datum';

class ViewUser extends React.Component<IAuthProps & RouteComponentProps<{id:string}>, {}> {
  private handleEdit = () => {
    this.props.history.push(`/users/edit/${parseInt(this.props.match.params.id)}`);
  }

  private handleDelete = () => {
    ToastService.toast("User deleted.");
    this.props.history.push('/users');
  }    

  private handleClickProfile(profile_id: number) {
    this.props.history.push(`/profiles/${profile_id}`);
  }

  render() {
    let p = this.props;
    return (
      <Viewer<User> 
        auth={p.auth}
        id={parseInt(p.match.params.id)}
        factory={UserFactory}
        canEdit='can_edit_users'
        canDelete='can_delete_users'
        onEdit={this.handleEdit}
        onDelete={this.handleDelete}
        content={(user: User) => 
          <React.Fragment>
            <Section dark padded="very">
              <Flex.Columns count={2}>
                <Flex>
                  <Flex.Row>
                    <Flex.Column>
                      <Gravatar email={user.email} size="tiny"/>
                    </Flex.Column>
                    <Flex.Column width={1}>
                      <div style={{height:'10px'}}/>
                      <Header size="h1">{user.name}</Header>
                    </Flex.Column>
                  </Flex.Row>
                </Flex>
                <div style={{textAlign: 'right'}}>
                  <Label basic onClick={(p.auth && p.auth.hasRight('can_view_profiles')) ? () => this.handleClickProfile(user.profile.id) : null}><Icon name="id-card" color="#888"/> {user.profile.name}</Label>
                  <Label basic><Icon name="envelope" color="#888"/> {user.email}</Label>
                  <Label basic>Last seen: &nbsp;{user.login_at ? <Datum.Distance value={user.login_at}/> : "never"}</Label>
                </div>
              </Flex.Columns>
            </Section>
            <Tabs underlined>
              <Tabs.Pane label="Log">
                <ListLogs auth={p.auth} name="user_logs" userId={user.id} {...p}/>
              </Tabs.Pane>
            </Tabs>
          </React.Fragment>}>
      </Viewer>
    );
  }
}

export { ViewUser };
